
import $ from 'jquery'
import _ from 'lodash'
import {Libs} from 'eyes-lib/es'
import * as Store from './modules/store'
import * as ShareFunc from './modules/sharefunc'
import Cookies from 'js-cookie'

import {Translate} from '../modules/multi-lang'


$(function(){


  /** @type {import("./modules/store").LoginInfo} 顧客情報 */
  const login = Store.App.storage.getItem(Store.objKey)

  //初めての場合は新規作成
  if(login == null){

    /** @type {import("./modules/store").LoginInfo} 顧客情報 */
    const login = Store.LoginInfo.new()

    login.uniquKey = getRndStr()

    Store.App.storage.setItem(Store.objKey,login)

  }

  $(".logininfo").val(JSON.stringify(login))

  //Email復元
  recodeEmail()

  /**
   * バリデーションデータの入れ替え
   * 一旦英語のみを考える
   * */

  const lang = Translate.language.getByURL().toUpperCase()

  if((lang != "JA") && (lang != "JP") && (lang != undefined)){

    var VALID_MESSAGE_REQUIRED = "This is required";
    var VALID_MESSAGE_PATTERN = "Please enter the correct syntax";
    var VALID_MESSAGE_TYPE = "Please enter in the specified format";

    $("input").each(function(index, elem) {

        if(elem.validity.valueMissing){
            elem.setCustomValidity(VALID_MESSAGE_REQUIRED);
        }

        elem.addEventListener("keyup", function (event) {
            if(elem.validity.valueMissing){
                elem.setCustomValidity(VALID_MESSAGE_REQUIRED);
            } else if(elem.validity.typeMismatch) {
                elem.setCustomValidity(VALID_MESSAGE_TYPE);
            } else {
                elem.setCustomValidity("");
            }
        });
    })
  }

	//全角を半角に変換
	$(".chgFullHalf").blur(function(){ 
		chgFullHalfStr($(this));
	});

  //全角を半角に変換
	$(".chgHalfFull").blur(function(){ 
		chgHalfFullStr($(this));
	});
})


//全角英数字を半角英数字に変換してセット
function chgFullHalfStr(chgElement){
  var str = chgElement.val();
  
  if(str.match(/[Ａ-Ｚａ-ｚ０-９]/g)){
    $(chgElement).val(zenkaku2hankaku(str));
  }
}

//全角英数字を半角英数字に変換した値を返却
function zenkaku2hankaku(str) {
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
}

//半角カナ英数字を全角カナ英数字に変換してセット
function chgHalfFullStr(chgElement){
  var str = chgElement.val();
  
  if(str.match(/[A-Za-z0-9]/g)){
    //半角英数字を全角英数字に変換してセット
    str = hankaku2zenkaku(str);
  }

  //半角カナを全角カナに変換してセット
  str = chgFullHalfKana(str);
  $(chgElement).val(str);
}

//半角英数字を全角英数字に変換した値を返却
function hankaku2zenkaku(str) {
  return str.replace(/[A-Za-z0-9]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
  });
}

//半角カナを全角カナに変換用
var kanaMap = {
  'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
  'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
  'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
  'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
  'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
  'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
  'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
  'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
  'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
  'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
  'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
  'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
  'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
  'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
  'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
  'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
  'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
  'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
  '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
};
var regkana = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');


//半角カナを全角カナに変換してセット
function chgFullHalfKanaStr(chgElement){
  var str = chgElement.val();
  
  $(chgElement).val(chgFullHalfKana(str));
}

//半角カナを全角カナに変換
function chgFullHalfKana(str) {
  return str.replace(regkana, function(s){
    return kanaMap[s];
  }).replace(/ﾞ/g, '゛').replace(/ﾟ/g, '゜');
}

function getRndStr(){
  //使用文字の定義
  var str = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

  //桁数の定義
  var len = 40

  //ランダムな文字列の生成
  var result = ""
  for(var i=0;i<len;i++){
    result += str.charAt(Math.floor(Math.random() * str.length));
  }
  return result;
}

function recodeEmail(){

  if(Cookies.get("loginemail") !== undefined){
    var email = JSON.parse(Cookies.get("loginemail"));
    $("#email").val(email.email)
    $("#recode").prop("checked",true)
  }

}